import React from 'react'
import CommonHeader from './commonheader/CommonHeader'
import Footer from './Footer'
import ContactDetails from './contact-us/ContactDetails'
import ContactForm from './contact-us/ContactForm'
import ContactMap from './contact-us/ContactMap'

const ContactUs = () => {
  return (
    <>
    <CommonHeader/>
    <ContactDetails/>
    <ContactForm/>
    <ContactMap/>
    <Footer/>
    </>
  )
}

export default ContactUs